<template>
    <div class="fixed pin-l w-full mx-auto my-3 px-6 bg-blue z-30 shadow">
        <div class="container py-3">
            <div class="flex justify-between mx-3">
                <slot name="left"></slot>
                <slot name="right"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {};
</script>
